<template>
  <v-sheet
    :elevation="elevation"
    data-testid="section-sheet"
    color="white"
    class="pb-4 section-sheet rounded"
  >
    <h1
      v-if="section.title"
      class="mt-0 mb-6 h4 grey--text text--darken-4 font-weight-regular"
      data-testid="section-title"
    >
      {{ section.title }}
    </h1>
    <v-container>
      <v-row class="my-0">
        <v-col cols="12">
          <FlexColumns
            data-testid="section-layout"
            :layout="section.layout"
            :widgets="section.widgets"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import FlexColumns from '@/containers/ReportsView/Layouts/FlexColumns.vue'

export default {
  name: 'Section',

  components: {
    FlexColumns,
  },

  props: {
    section: {
      type: Object,
      required: true,
    },
    elevation: {
      type: Number,
      required: false,
      default: 1,
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen {
  .section-sheet {
    padding: 48px;
  }
}

@media print {
  .section-sheet {
    padding: 0px !important;
  }
}
</style>
